import styled from '@emotion/styled';
import { Component as ComponentContainer } from '@styles/layout';
import { CarouselComponent, CarouselTypes } from '@model/content';
import { HomeCarousel } from '@components/homepage/HomeCarousel';
import { FixedCarousel } from '@components/common';
import { IconCarousel } from '@components/common/carousel/IconCarousel';

const Container: any = styled.div({});

export const CarouselContainer = ({ tiles, type }: CarouselComponent) => {
  if (type === CarouselTypes.HERO) {
    return (
      <Container>
        <HomeCarousel tiles={tiles} />
      </Container>
    );
  } else {
    if (tiles.some(({ icon }) => !!icon)) {
      return <IconCarousel tiles={tiles} />;
    } else {
      return (
        <ComponentContainer css={{ boxSizing: 'border-box' }}>
          <FixedCarousel tiles={tiles} />
        </ComponentContainer>
      );
    }
  }
  return null;
};
